export enum OpenReposGridColumnId {
  OPEN_REPOS_STATUS = 'OPEN_REPOS_STATUS',
  OPEN_REPOS_DIRECTION = 'OPEN_REPOS_DIRECTION',
  OPEN_REPOS_COLLATERAL_NAME = 'OPEN_REPOS_COLLATERAL_NAME',
  OPEN_REPOS_BOND_PRICE = 'OPEN_REPOS_BOND_PRICE',
  OPEN_REPOS_NOTIONAL = 'OPEN_REPOS_NOTIONAL',
  OPEN_REPOS_START_DATE = 'OPEN_REPOS_START_DATE',
  OPEN_REPOS_END_DATE = 'OPEN_REPOS_END_DATE',
  OPEN_REPOS_RATE = 'OPEN_REPOS_RATE',
  OPEN_REPOS_HAIRCUT = 'OPEN_REPOS_HAIRCUT',
  OPEN_REPOS_COLLATERAL_ISIN_OR_BUI = 'OPEN_REPOS_COLLATERAL_ISIN_OR_BUI',
  OPEN_REPOS_PRODUCT = 'OPEN_REPOS_PRODUCT',
  OPEN_REPOS_PRODUCT_SECTOR = 'OPEN_REPOS_PRODUCT_SECTOR',
  OPEN_REPOS_COLLATERAL_CURRENCY = 'OPEN_REPOS_COLLATERAL_CURRENCY',
  OPEN_REPOS_TRADE_DATE = 'OPEN_REPOS_TRADE_DATE',
  OPEN_REPOS_TRADE_TIME = 'OPEN_REPOS_TRADE_TIME',
  OPEN_REPOS_START_CONSIDERATION = 'OPEN_REPOS_START_CONSIDERATION',
  OPEN_REPOS_END_CONSIDERATION = 'OPEN_REPOS_END_CONSIDERATION',
  OPEN_REPOS_COUNTERPARTY_NAME = 'OPEN_REPOS_COUNTERPARTY_NAME',
  OPEN_REPOS_MY_ENTITY = 'OPEN_REPOS_MY_ENTITY',
  OPEN_REPOS_UPDATED_BY = 'OPEN_REPOS_UPDATED_BY',
  OPEN_REPOS_UPDATED_AT_DATE = 'OPEN_REPOS_UPDATED_AT_DATE',
  OPEN_REPOS_UPDATED_AT_TIME = 'OPEN_REPOS_UPDATED_AT_TIME',
  OPEN_REPOS_UTI = 'OPEN_REPOS_UTI'
}
